import { OuPromptContext } from '10.quickConnect.app/components/shared/Dialogs/OuSwitchPrompt/types';

/** Message de la popup de bascule : déclaration existante (brouillon, duplication), inbox, ou formulaire */
export const getOuPromptContext = (declarationId: string | undefined, inboxId: string | undefined): OuPromptContext => {
  if (declarationId) return 'declaration';
  return inboxId ? 'inbox' : 'form';
};
